export const validation_errors = {
  field: {
    start: 'Bidang tanggal mulai:',
    end: 'Bidang tanggal akhir:',
    number: 'Bidang nomor:',
    status: 'Bidang status:',
    state: 'Bidang status:',
    name: 'Bidang nama:',
    login: 'Login'
  },
  value: {
    'Peer already exists': 'sudah ada',

    validation: {
      required: 'wajib diisi',
      integer: 'harus berupa angka',
      string: 'harus berupa string'
    },
    'Date range must be less a month': 'Rentang tanggal tidak boleh lebih dari 1 bulan'
  },
  enter_date: 'Tentukan tanggal'
};
